$(document).ready(function() {
    $('.btn-form-open').on('click', function() {
        $('#lightbox-right-form iframe').attr('src', consultation_form);
    });

    // Duplicate Form
    $('.lightbox-container .lightbox-shadow, .lightbox-container .lightbox-close, .lightbox-container .btn-close-modal').on('click', function() {
        var $iframe = $('#lightbox-right-form iframe')[0];
        if ($iframe && typeof $iframe.contentWindow.closeForm === 'function') {
            $iframe.contentWindow.closeForm().then(() => {
                closeLightbox();
            }).catch(() => {
                closeLightbox();
            });
        } else {
            closeLightbox();
        }
    });

    function closeLightbox() {
        $('#lightbox-right-form').removeClass('lightbox-active');
        $('#lightbox-right-form .lightbox-content-title').empty();
        $('#lightbox-right-form .lightbox-content-text').empty();
        $('#lightbox-right-form .lightbox-content-button').empty();
        $('body').removeClass('overflow-hidden');
        $('body').removeClass('body-noscroll');
    }
});
